/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The RuntimeMethodHandle model module.
 * @module model/RuntimeMethodHandle
 * @version V1
 */
class RuntimeMethodHandle {
    /**
     * Constructs a new <code>RuntimeMethodHandle</code>.
     * @alias module:model/RuntimeMethodHandle
     */
    constructor() { 
        
        RuntimeMethodHandle.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>RuntimeMethodHandle</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/RuntimeMethodHandle} obj Optional instance to populate.
     * @return {module:model/RuntimeMethodHandle} The populated <code>RuntimeMethodHandle</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new RuntimeMethodHandle();

            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], Object);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>RuntimeMethodHandle</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>RuntimeMethodHandle</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Object} value
 */
RuntimeMethodHandle.prototype['value'] = undefined;






export default RuntimeMethodHandle;

